import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-46363ea6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "item-header flex align-center justify-between"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "info"
  }, "查看详情>", -1);
});
var _hoisted_4 = {
  class: "item-content"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "领用人：", -1);
});
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "申请时间：", -1);
});
var _hoisted_8 = {
  class: "info"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "领用部门：", -1);
});
var _hoisted_10 = {
  class: "info"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "物料名称：", -1);
});
var _hoisted_12 = {
  class: "info"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "单据状态：", -1);
});
var _hoisted_14 = {
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "ReleaseItem",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.toMaterialList && _ctx.toMaterialList.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.release_no), 1), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.u_name), 1)]), _createElementVNode("div", null, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.item.create_time), 1)]), _createElementVNode("div", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.item.dept_name), 1)]), _createElementVNode("div", null, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.item.stone_txt), 1)]), _createElementVNode("div", null, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.statusFormat(_ctx.item.release_status)), 1), _createElementVNode("span", {
    class: "link",
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.openLink(_ctx.item.oa_request_id);
    }, ["stop"]))
  }, "关联审批单")])])]);
}